import { Injectable } from '@angular/core';
import { Folder } from '@ca/core/models';
import { FileService, UserNotificationService } from '@ca/core/services';
import { EMPTY, Observable, iif, of, throwError } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

@Injectable()
export class CreateAndStartFacadeService {
    constructor(
        private fileService: FileService,
        private userNotificationService: UserNotificationService,
    ) {}

    checkFolderAndRenameTemporaryFolderToRunName$(uploadFolder: Folder, parentFolderName: string, runName: string): Observable<void | Folder> {
        return this.fileService.checkFolderExistence$([parentFolderName, runName.trim()]).pipe(
            mergeMap((folder: Folder | null) =>
                iif(
                    () => folder != null,
                    throwError(new Error('CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.ERRORS.NAME_ALREADY_EXISTS_AS_FOLDER')),
                    of(void 0),
                ),
            ),
            switchMap(() => {
                // rename temporary upload folder name to entered run name to match folder name and run name
                return this.fileService.renameFolder$(uploadFolder, runName.trim());
            }),
            catchError((error: unknown) => {
                if (error instanceof Error) {
                    this.userNotificationService.showError(error.message);
                } else {
                    this.userNotificationService.showError('CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.ERRORS.TRY_AGAIN_OR_CONTACT');
                }
                return EMPTY;
            }),
        );
    }
}
